import { alpha, styled } from "@mui/material/styles";
import MuiToggleButton from "@mui/material/ToggleButton";
import MuiToggleButtonGroup from "@mui/material/ToggleButtonGroup";

// 도메인 무관 토글 버튼 프리미티브.
// 선택 상태는 테마 primary 토큰을 사용한다(canonical). MUI 표준 color="primary"
// 선택 스타일과 동일한 모양이라 prop 지정 없이도 화면 전반에서 일관된다.
export const StyledToggleButton = styled(MuiToggleButton)(({ theme }) => ({
  "&.Mui-selected": {
    color: theme.palette.primary.main,
    backgroundColor: alpha(
      theme.palette.primary.main,
      theme.palette.action.selectedOpacity
    ),
    "&:hover": {
      backgroundColor: alpha(
        theme.palette.primary.main,
        theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity
      ),
    },
  },
}));

// 그룹은 MUI 기본을 그대로 노출(향후 공통 간격/구분선 조정 시 여기서 일괄 처리).
export const ToggleButtonGroup = MuiToggleButtonGroup;

export default StyledToggleButton;
